import React from 'react';
import { get } from 'lodash';

import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import PersonalKostenVN, { GetVNPersonalKostenFormStruc } from './PersonalKostenVN';
const P = Schema.attributes;

export const GetPersonalKostenVN = (application: any, kostenKategories: any) => {
	const OrgaStruc = [
		{
			label: 'Antragsteller',
			content: (
				<PersonalKostenVN kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />
			),
			formStruc: GetVNPersonalKostenFormStruc(
				application,
				get(getLocalstorageToken(), 'organisationId'),
				'Antragsteller',
				kostenKategories,
			),
		},
	];
	const PartnerStruc = get(application, P.Zuwendungsantrag.schema.attributes.Partner.path, []).map((ele: any, i: number) => {
		return {
			label: `Partner ${i + 1}`,
			content: <PersonalKostenVN kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
			formStruc: GetVNPersonalKostenFormStruc(application, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
		};
	});
	return [...OrgaStruc, ...PartnerStruc];
};
